import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useThemeColors } from '../hooks/useThemeColors';
import { getCurrentUser } from '../redux/auth/authSlice';
import { saveUserAddress } from '../redux/pos/posSlice';

// Initial state for the form
const initialAddressState = {
  name: '',
  mobileNumber: '',
  building: '',
  flat: '',
  address: '',
  latitude: '0',
  longitude: '0',
  latitudeDelta: '0',
  longitudeDelta: '0',
  useMyLocation: false,
};

const DeliveryPopup = ({ show, onClose, darkMode }) => {
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUser);
  const savedAddresses = useSelector((state) => state.pos.userAddressList);
  const { cardBg, textColor, subTextColor, borderColor, isDark } =
    useThemeColors(darkMode);

  const [address, setAddress] = useState(initialAddressState);

  // useEffect(() => {
  //   if (show && user?.referenceId) {
  //     dispatch(getUserAddress({ userId: user.referenceId }));
  //   }
  // }, [show, user?.referenceId, dispatch]);

  useEffect(() => {
    if (show && savedAddresses && savedAddresses.length > 0) {
      const lastSaved = savedAddresses[0];
      setAddress({
        ...initialAddressState,
        ...lastSaved,
        userId: user?.referenceId,
      });
    } else {
      setAddress((prev) => ({
        ...initialAddressState,
        userId: user?.referenceId,
      }));
    }
  }, [savedAddresses, show, user?.referenceId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveAddress = (e) => {
    e.preventDefault();

    const payload = {
      ...address,
      userId: user?.referenceId,
    };

    dispatch(saveUserAddress(payload));
    onClose();
  };

  if (!show) return null;
  const inputClass = `form-control border shadow-none ${
    isDark ? 'bg-dark text-white' : 'bg-white text-dark'
  }`;

  const labelStyle = {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '0.85rem',
    color: subTextColor,
  };

  return (
    <div
      className="delivery-popup-overlay d-flex justify-content-center align-items-center"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.75)',
        zIndex: 2000,
        backdropFilter: 'blur(5px)',
      }}
    >
      <div
        className="shadow-lg border-0"
        style={{
          width: '90%',
          maxWidth: '450px',
          backgroundColor: cardBg,
          borderRadius: '15px',
          padding: '25px',
          position: 'relative',
        }}
      >
        <button
          className="btn position-absolute border-0"
          style={{ top: '10px', right: '10px', color: subTextColor }}
          onClick={onClose}
        >
          <FaTimes size={20} />
        </button>

        <h4 className="fw-bold mb-4" style={{ color: textColor }}>
          Delivery Details
        </h4>

        <form onSubmit={handleSaveAddress}>
          <div className="mb-3">
            <label style={labelStyle}>Customer Name</label>
            <input
              type="text"
              name="name"
              className={`${inputClass} py-2`}
              style={{ borderColor: borderColor }}
              value={address.name || ''}
              onChange={handleInputChange}
              placeholder="Enter name"
              required
            />
          </div>

          <div className="mb-3">
            <label style={labelStyle}>Mobile No</label>
            <input
              type="tel"
              name="mobileNumber"
              className={`${inputClass} py-2`}
              style={{ borderColor: borderColor }}
              value={address.mobileNumber || ''}
              onChange={handleInputChange}
              placeholder="03xx xxxxxxx"
              required
            />
          </div>

          <div className="mb-3">
            <label style={labelStyle}>Building / House No.</label>
            <input
              type="text"
              name="building"
              className={`${inputClass} py-2`}
              style={{ borderColor: borderColor }}
              value={address.building || ''}
              onChange={handleInputChange}
              placeholder="Flat/House No."
              required
            />
          </div>

          <div className="mb-4">
            <label style={labelStyle}>Street Address / Landmark</label>
            <input
              type="text"
              name="address"
              className={`${inputClass} py-2`}
              style={{ borderColor: borderColor }}
              value={address.address || ''}
              onChange={handleInputChange}
              placeholder="Complete address details..."
              required
            />
          </div>

          <button
            type="submit"
            className="btn w-100 py-2 fw-bold mb-2 shadow-sm rounded"
            style={{
              backgroundColor: '#e4002b',
              color: 'white',
              border: 'none',
            }}
          >
            CONFIRM ADDRESS
          </button>

          <button
            type="button"
            className="btn w-100 py-2 fw-bold rounded border"
            style={{
              backgroundColor: isDark ? '#333' : '#f8f9fa',
              color: textColor,
              borderColor: borderColor,
            }}
            onClick={onClose}
          >
            CLOSE
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeliveryPopup;
